import { currencyGivenPennies } from 'core/utils';
import { LoadingType, useOrderDetails } from 'hooks/orderDetails';
import * as React from 'react';
import './order-summary.scss';

interface Props {
  mods?: string;
}

const OrderSummary = ({ mods = '' }: Props) => {
  const { order, loading: hookLoading } = useOrderDetails();
  const loading = hookLoading[LoadingType.GetOrder];

  return (
    <div
      className={`order-details-summary u-flex ${mods}${
        loading ? ' loading' : ''
      }`}
    >
      <div
        className="order-summary-card u-padXl"
        data-testid="order-summary--current-balance-container"
      >
        <span data-testid="order-summary--current-balance-label">
          {!loading ? 'Current Balance' : ''}
        </span>
        <p
          className="u-fontSize3x u-textBold"
          data-testid="order-summary--current-balance-value"
        >
          {!loading ? currencyGivenPennies(order?.amountRemaining) : ''}
        </p>
      </div>
      <div
        className="order-summary-card u-padXl"
        data-testid="order-summary--total-fees-container"
      >
        <span data-testid="order-summary--total-fees-label">
          {!loading ? 'Total Fees' : ''}
        </span>
        <p
          className="u-fontSize3x u-textBold"
          data-testid="order-summary--total-fees-value"
        >
          {!loading ? currencyGivenPennies(order?.amount) : ''}
        </p>
      </div>
      <div
        className="order-summary-card u-padXl"
        data-testid="order-summary--total-paid-container"
      >
        <span data-testid="order-summary--total-paid-label">
          {!loading ? 'Total Paid' : ''}
        </span>
        <p
          className="u-fontSize3x u-textBold"
          data-testid="order-summary--total-paid-value"
        >
          {!loading
            ? currencyGivenPennies(
                (order?.amountPaid ?? 0) - (order?.amountRefunded ?? 0)
              )
            : ''}
        </p>
      </div>
    </div>
  );
};

export default OrderSummary;
